import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { t } from 'utils/translates';

import NoticeSetReadOneButton from './ActionsButtons/NoticeSetReadOneButton';

// eslint-disable-next-line react/prefer-stateless-function
class NotificationsListItem extends Component {
  render() {
    return (
      <div
        className="panel-notify"
        style={
          this.props.item.noticeAppStatus === 1
            ? {
                background: '#fffddd'
              }
            : {}
        }
      >
        <div className="media">
          <div className="media-left media-middle">
            <div className="avatar avatar-icon avatar-icon-sm avatar-icon-primary">
              <i className="fa fa-star fa-lg" />
            </div>
          </div>
          <div className="media-body media-middle">
            <div className="media-info">
              <span className="media-info-name">
                {this.props.item.typeTitle}
              </span>{' '}
              <span className="media-info-desc">
                {this.props.item.createdAtFormatted}
              </span>
            </div>
            <div>{this.props.item.message}</div>
          </div>
          <div className="pull-right">
            {this.props.item.noticeAppStatus === 1 ? (
              <span>
                <NoticeSetReadOneButton noticeId={this.props.item.id} />
                {' / '}
              </span>
            ) : null}
            <Link to={`/notifications/view/${this.props.item.id}`}>
              {t('Подробнее')}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

NotificationsListItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    noticeAppStatus: PropTypes.number.isRequired,
    typeTitle: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    createdAtFormatted: PropTypes.string.isRequired
  }).isRequired
};

export default NotificationsListItem;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Notifications/NotificationsList/NotificationsListItem.js